<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Poste Voyages" />
            <PosteVoyage />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import PosteVoyage from '../Services/PosteVoyage'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'PosteVoyagePage',
    components: {
        NavBar,
        PageTitle,
        PosteVoyage,
        FooterComp,
    }
}
</script>